
import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Header from '../../components/header/LoginHeaderR';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/FooterW';
import Terms from '../../components/TermsService/termsservice';

const TermsServiceR = (props) => {

    return (
        <Fragment>
            <div className='index_ico page_wrapper'>
                <Header />
                <main className="page_content">
                    <PageTitle pageTitle={'Terms & Service'} pagesub={'Home'} />
                    <Terms abClass={'pt-0'}/>
                  
                </main>
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    )
};
export default TermsServiceR;